/* eslint-disable max-len */
import React from 'react';
import classNames from 'classnames';

import { starRatingTypes } from './propTypes';

import './ProductReviewRatingStars.scss';

function FullStar () {

	return (
		<span
			data-ugctest-star
			data-ugctest="fullstar"
			className="lpIcon-star-selected ProductReviewRatingStars__stars--fullStarRating"
		/>
	);

}

function HalfStar () {

	return (
		<span
			data-ugctest-star
			data-ugctest="halfstar"
			className="lpIcon-star-selected ProductReviewRatingStars__stars--halfStarRating"
		/>
	);

}

function EmptyStar () {

	return (
		<span
			data-ugctest-star
			data-ugctest="emptystar"
			className="lpIcon-star-selected ProductReviewRatingStars__stars--emptyStarRating"
		/>
	);

}

// type: filled, half, empty
function Star ({ type }) {

	switch (type.toUpperCase()) {

		case 'FILLED':
			return <FullStar />;
		case 'HALF':
			return <HalfStar />;
		case 'EMPTY':
			return <EmptyStar />;
		default:
			return '';

	}

}

const ProductReviewRatingStars = ({
	rating, size, styleVariant, showSummaryText
}) => {

	const starsClass = classNames('ProductReviewRatingStars__stars', {
		[`ProductReviewRatingStars__stars--${size}`]: true,
		[`ProductReviewRatingStars__stars--${styleVariant}`]: true
	});

	function renderStars () {

		if (typeof rating !== 'number' || rating === 0) {

			return '';

		}

		// check if rating is a whole number (example: 5 or 5.0)
		if (rating % 1 === 0) {

			const ratingInt = Number(rating);

			return (
				<div className={starsClass}>
					{[ ...Array(ratingInt).keys() ].map((ratingValue) => (
						<Star key={`star_rating_${ratingValue}`} type="filled" />
					))}
					{[ ...Array(5 - ratingInt).keys() ].map((ratingValue) => (
						<Star key={`star_rating_${ratingValue}`} type="empty" />
					))}
				</div>
			);

		}

		const ratingInt = Number(parseFloat(rating).toFixed(1).split('.')[0]);
		const decimals = Number(parseFloat((rating % 1).toFixed(1)));

		const stars = [ ...Array(5).keys() ].reduce((acc, ratingValue) => {

			if (ratingValue < ratingInt) {

				acc.push(<Star key={`star_rating_${ratingValue}`} type="filled" />);

			} else if (ratingValue > ratingInt) {

				acc.push(<Star key={`star_rating_${ratingValue}`} type="empty" />);

			} else if (ratingValue === ratingInt) {

				if (decimals >= 0.3 && decimals <= 0.7) {

					acc.push(<Star key={`star_rating_${ratingValue}`} type="half" />);

				} else if (decimals > 0.7) {

					acc.push(<Star key={`star_rating_${ratingValue}`} type="filled" />);

				} else if (decimals < 0.3) {

					acc.push(<Star key={`star_rating_${ratingValue}`} type="empty" />);

				}

			}

			return acc;

		}, []);

		return (
			<div className={starsClass}>
				{stars.map((star) => star)}
			</div>
		);

	}

	return (
		<div className="ProductReviewRatingStars">
			{showSummaryText && (
				<div className="ProductReviewRatingStars__summary">
					<span className="ProductReviewRatingStars__summaryCount" data-ugctest="rating count">
						{rating.toFixed(1)}
					</span>
					{' '}
					<span className="ProductReviewRatingStars__summaryText">out of 5 stars</span>
				</div>
			)}
			{renderStars()}
		</div>
	);

};

ProductReviewRatingStars.defaultProps = {
	size: 'normal',
	showSummaryText: false,
	styleVariant: 'primary'
};
ProductReviewRatingStars.propTypes = starRatingTypes;

export default ProductReviewRatingStars;
